<template>
	<div>
		<vue-headful
				:title="title">
		</vue-headful>
		<b-modal v-model="showExportModal" ok-title="Close" ok-only>
			<a v-if="exportModalFileType === 'xlsx'" :href="exportModalUrl" target="_blank"
			   :download="exportModalFileName">Download File</a>
			<a v-else :href="exportModalUrl" target="_blank" :download="exportModalFileName">Download File</a>
		</b-modal>
		<AdvancedSearch
				ref="advSearch"
				v-model="showAdvancedSearch"
				:key="advancedSearchKey"
				:entity="this.restEntity"
				:fields="fieldNames"
				:columns="columnMap"
				:limit="rowsPerPage"
				:criteria="advancedSearchCriteria"
				@advanced-search="advancedSearch"
				@advanced-search-cancel="cancelAdvancedSearch"
				@update-search-criteria="updateSearchCriteria"
		></AdvancedSearch>
		<vue-element-loading :active="show"></vue-element-loading>
		<div class="row" v-show="showExport">
			<ul class="col-12 nav justify-content-end">
				<li class="nav-item"><a href="" @click.prevent="exportToExcel">Export to Excel
					<font-awesome-icon class="ml-1" icon="file-excel"></font-awesome-icon>
				</a></li>
				<li class="nav-item pl-3"><a href="" @click.prevent="saveAsPdf">Save as PDF
					<font-awesome-icon class="ml-1" icon="file-pdf"></font-awesome-icon>
				</a></li>
			</ul>
		</div>
		<div class="card">
			<div class="card-header py-1">
				<div class="d-flex justify-content-between align-items-center">
					<div>{{ headerTitle }}</div>
					<div class="form-inline">
						<form @submit.prevent="quickFind" id="search-form" class="form-inline input-group">
							<label>Search</label>
							<input @keyup.delete="searchOnClear" v-model="searchCriteria"
								   class="form-control form-control-sm ml-1"/>
							<div class="input-group-append">
								<button class="btn btn-sm btn-outline-primary">Go</button>
							</div>
						</form>
						<button :class="[hasAdvancedSearchCriteria ? 'btn-success' : '']"
								@click.prevent="showAdvancedSearch = true" class="btn btn-primary ml-3">Advanced
							Search
						</button>
					</div>
				</div>
			</div>
			<div class="card-body" style="padding-bottom: 0.5rem;">
				<b-table
						ref="listViewTable"
						id="listViewTable"
						:fields="fields"
						:items="pageInputHandler"
						:per-page="rowsPerPage"
						:current-page="page"
						:sort-compare="sortCompare"
						empty-text="No records found"
						sticky-header="70vh"
						primary-key="primaryKey"
						:show-empty="true"
						responsive
						small
						hover
						style="border-bottom: thin solid rgb(222, 226, 230); margin-bottom: 0.5rem;"
				>
					<template v-slot:head(lockedField)="scope">
											<span style="margin-right: 0.25em;">
												<font-awesome-icon icon="lock"></font-awesome-icon>
											</span>
					</template>
					<template v-slot:[percentFillColumn]="data">
						{{ data.value | format(data.field.format) }}
					</template>
					<template
							v-if="restEntity !== 'companies' && restEntity !== 'registrations' && restEntity !== 'dictionaries'"
							v-slot:cell(lockedField)="data">
						<font-awesome-icon v-if="data.item[lockedColumn] === 'Yes'" icon="lock"
										   class="mr-1"></font-awesome-icon>
					</template>
					<template v-slot:[leftmostColumn]="data">
						<router-link
								v-if="$route.name !== 'dictionaries'"
								:to="{name: restDetailEntity, params: {id: data.item.recordId}}">
							<font-awesome-icon icon="eye" class="mr-1"></font-awesome-icon>
						</router-link>
						{{ data.value }}
					</template>
					<template v-slot:cell(locked)="data">
						<font-awesome-icon
								v-if="data.item['Containers::Locked Container'] === 'Yes'"
								icon="lock"></font-awesome-icon>
						<span v-else>&nbsp;</span>
					</template>
				</b-table>
				<div class="d-flex justify-content-between align-items-center w">
					<div class="small">
						<span v-if="maxRows > 0">
							Showing
							{{
								rowsPerPage
								* (page - 1) + 1
							}} to {{
								Math.min(rowsPerPage * page,
										maxRows)
							}} of
							{{ maxRows }} entries
						</span>
					</div>
					<b-pagination
							size="sm"
							:total-rows="maxRows"
							:per-page="rowsPerPage"
							v-model="page"
							align="right"
					></b-pagination>
				</div>
			</div>
		</div>
		<!--<Grid
            ref="listView"
            v-on:goto-page="goToPage"
            v-on:update-rows-per-page="updateRowsPerPage"
            :rows="rows"
            :columns="columns"
            :rows-per-page="rowsPerPage"
            :max-rows="maxRows"
            :page="page"
            :header-title="headerTitle"
            :rest-detail-entity="restDetailEntity"
            :has-detail-column="hasDetailColumn"
            :advanced-search-criteria="advancedSearchCriteria"
            @advanced-search="showAdvancedSearch = true"
        >
        </Grid>-->
	</div>
</template>

<script>
import Grid from '../components/Grid.vue'
import AdvancedSearch from "./AdvancedSearch"
import feedbackMixin from "../mixins/feedback"
import exportFileMixin from "../mixins/export-file"

export default {
	name: "ListViewTemplate",
	components: {AdvancedSearch, Grid},
	mixins: [feedbackMixin, exportFileMixin],
	data() {
		return {
			searchType: '',
			show: false,
			hasDetailColumn: true,
			showAdvancedSearch: false,
			hideAdvancedSearchFooter: false,
			restEntity: '',
			showExport: false,
			columnMap: {},
			percentFillColumn: 'cell(Percent Fill)',
			advancedSearchKey: 0
		}
	},
	computed: {
		title: function () {
			return this.$route.meta.title ? this.$route.meta.title : this.$options.name
		},
		fieldNames: function () {
			return this.columns.map(value => {
				return {
					text: value.searchName ? value.searchName : value.displayName
				}
			})
		},
		hasAdvancedSearchCriteria: function () {
			return this.advancedSearchCriteria.length > 0 && JSON.stringify(this.advancedSearchCriteria) !== JSON.stringify([{'omit': 'false'}])
		}
	},
	mounted: function () {
		this.advancedSearchKey = 0
		this.columnMap = this.createColumnMap()
	},
	methods: {
		sortCompare: function (aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
			const a = aRow[key] // or use Lodash `_.get()`
			const b = bRow[key]
			if (
				(typeof a === 'number' && typeof b === 'number') ||
				(a instanceof Date && b instanceof Date) || (a.date && b.date)
			) {
				// If both compared fields are native numbers or both are native dates
				return a < b ? -1 : a > b ? 1 : 0
			} else {
				// Otherwise stringify the field data and use String.prototype.localeCompare
				return toString(a).localeCompare(toString(b), compareLocale, compareOptions)
			}
		},
		createColumnMap: function () {
			let returnValue = {};
			for (let elementIndex in this.columns) {
				let element = this.columns[elementIndex];
				let index = element.searchName ? element.searchName : element.displayName;
				returnValue[index] = element.name
			}
			return returnValue
		},
		advancedSearch: function () {
			this.searchType = 'ADVANCED';
			this.page = 1
			this.$root.$emit('bv::refresh::table', 'listViewTable');
			return false
		},
		quickFind: function () {
			this.searchType = 'QUICK'
			this.page = 1
			this.$root.$emit('bv::refresh::table', 'listViewTable')
		},
		searchOnClear: function () {
			if (this.searchCriteria === '') {
				this.quickFind()
			}
		},
		pageInputHandler: function (ctx) {

			let quickFind = true

			if (this.searchType === 'QUICK') {
				quickFind = true
			} else if (this.searchType === 'ADVANCED' || this.hasAdvancedSearchCriteria) {
				quickFind = false
			}

			let limit = this.rowsPerPage;
			let offset = limit * (ctx.currentPage - 1);

			let that = this
			return this.goToPage({
				limit: limit,
				offset: offset,
				page: ctx.currentPage,
				searchCriteria: quickFind ? this.searchCriteria : this.advancedSearchCriteria,
				quickFind: quickFind,
				sort: ctx.sortBy ? [{
					fieldName: ctx.sortBy,
					sortOrder: ctx.sortDesc ? "descend" : "ascend"
				}] : null
			})
				.then(value => {
					// console.log('goToPage async request succeeded');
					if (quickFind) {
						this.advancedSearchCriteria = [];
						this.$refs.advSearch.criteria = [[]]
					} else {
						this.searchCriteria = ''
					}
					if (value.length > 0) {
						this.showAdvancedSearch = false
					}
					return value
				})
				.catch(value => {
					console.log('goToPage async request failed');
					return value
				})
				.finally(() => {
					this.searchType = ''
				})
		},
		updateSearchCriteria: function (payload) {
			this.advancedSearchCriteria = payload.searchCriteria
		},
		cancelAdvancedSearch: function () {
			this.clearErrors();
			this.showAdvancedSearch = false;
			this.$root.$emit('bv::refresh::table', 'listViewTable')
		}
	}
}
</script>

<style scoped>

</style>